import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "rich-text-editor-badges"
    }}>{`Rich Text Editor Badges`}</h1>
    <p>{`A badge is a non-editable block inside RTE that could be styled differently and may have a custom behavior. At this point, the only custom behavior is that badges are non-editable and could be only removed as a whole item.
A badge could be added using the following API:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`rte: {
  getBadges: () => [
    {
      id: "variable",
      prefix: "!",
      suffix: "!",
      backgroundColor: "#D6F1FF",
      textColor: "#54719B"
    }
  ]
}
`}</code></pre>
    <p>{`Where, prefix and suffix symbols define a badge boundaries in the text/html, backgroundColor and textColor define badge styling. Example:`}</p>
    <p><img parentName="p" {...{
        "src": "/uix/docs/assets/c00900dfbef6d320261d60b5b3b21b75/badges.gif",
        "alt": null
      }}></img></p>
    <h2 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h2>
    <h3 {...{
      "id": "extension-api"
    }}>{`Extension API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Field`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Must be unique`}</strong>{` across all extensions. Consider adding a vendor prefix to this field.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`prefix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`char`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Badge starting character`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`suffix`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`char`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Badge ending character`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`backgroundColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`HEX or text CSS color code for the background`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`textColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✔️`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`HEX or text CSS color code for the text`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "instructions-api"
    }}>{`Instructions API`}</h3>
    <p>{`Widget window `}<strong parentName="p">{`MAY`}</strong>{` call a `}<inlineCode parentName="p">{`connection.host.rte.applyInstructions`}</inlineCode>{` method and provide RTE instruction to execute:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Instruction`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`replaceContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replaces current editor content with a content provided in `}<inlineCode parentName="td">{`value`}</inlineCode>{` property`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`insertContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Inserts a content provided in `}<inlineCode parentName="td">{`value`}</inlineCode>{` property in current carret position`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      